// The policy pages (built by tools/build-legal.py): the shared chrome, the contents list that follows the
// reader, and the opt-out panel on /privacy-choices.
import { $, $$, initChrome } from 'v2/ui.js';
import { gpc, optedOut, setOptOut } from 'v2/privacy.js';

initChrome();

/* ---------- Contents: open beside the text on desktop, folded above it on phones ---------- */
const toc = $('[data-toc]');
if (toc) {
  const wide = matchMedia('(min-width: 1000px)');
  const fit = () => { toc.open = wide.matches; };
  fit();
  wide.addEventListener('change', fit);
  toc.addEventListener('click', (e) => { if (e.target.closest('a') && !wide.matches) toc.open = false; });

  // The section being read: the last heading above the top third of the screen.
  const links = new Map($$('a[href^="#"]', toc).map((a) => [a.getAttribute('href').slice(1), a]));
  const heads = [...links.keys()].map((id) => document.getElementById(id)).filter(Boolean);
  let current = null;
  const mark = () => {
    const line = innerHeight * 0.33;
    let id = null;
    for (const h of heads) { if (h.getBoundingClientRect().top <= line) id = h.id; else break; }
    if (id === current) return;
    current = id;
    links.forEach((a, key) => { if (key === id) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
    // A long list scrolls inside its column: keep the current entry in sight.
    const a = links.get(id);
    if (a && wide.matches && toc.scrollHeight > toc.clientHeight) {
      const top = a.offsetTop;
      const bottom = top + a.offsetHeight;
      if (top < toc.scrollTop + 48) toc.scrollTop = top - 48;
      else if (bottom > toc.scrollTop + toc.clientHeight - 48) toc.scrollTop = bottom - toc.clientHeight + 48;
    }
  };
  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { mark(); ticking = false; });
  }, { passive: true });
  mark();
}

/* ---------- Your Privacy Choices: opt this browser out ---------- */
const panel = $('[data-optout]');
if (panel) {
  const render = (justNow = false) => {
    const signal = gpc();
    const out = optedOut();
    panel.classList.toggle('is-out', out);
    $('[data-optout-gpc]', panel).hidden = !signal;
    $('[data-optout-form]', panel).hidden = out;
    $('[data-optout-done]', panel).hidden = !out;
    $('[data-optout-status]', panel).textContent = justNow ? 'You have successfully opted out' : 'The browser on this device is opted out';
    // A Global Privacy Control signal can't be undone from the page; a click can.
    $('[data-optout-undo]', panel).hidden = signal || !out;
  };
  $('[data-optout-btn]', panel).addEventListener('click', () => { setOptOut(true); render(true); $('[data-optout-status]', panel).focus(); });
  $('[data-optout-undo]', panel).addEventListener('click', () => { setOptOut(false); render(); $('[data-optout-btn]', panel).focus(); });
  render();
}
